// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Ycn3c","overflowing":"ReadFullNote_overflowing__2OcEh"};